import { render, staticRenderFns } from "./UserFamilyTable.vue?vue&type=template&id=46093dfe&"
import script from "./UserFamilyTable.vue?vue&type=script&lang=js&"
export * from "./UserFamilyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports